<template>
  <WizardStep
    v-if="canManageCurrency"
    heading="Manage Currency"
    :hideFooter="true"
    class="py-5"
  >
    <template v-slot:content>
      <v-container>
        <v-layout row wrap>
          <v-flex>
            <v-card elevation="2">
              <v-card-title>{{ activeCurrencyTitle }}</v-card-title>
              <v-card-text>
                <v-layout row wrap class="px-5">
                  <div
                    class="pb-3 pr-3"
                    v-for="currency in enabledCurrencyList"
                    :key="currency.value"
                  >
                    <v-chip
                      :color="currency.enabled ? 'green' : 'red'"
                      :disabled="isChipDisabled(currency.value)"
                      close
                      :small="!currency.enabled"
                      :close-icon="currency.enabled ? '$close' : '$plus'"
                      @click:close="chipCloseAction(currency)"
                    >
                      {{ currency.text }}
                    </v-chip>
                  </div>
                </v-layout>
                <hr />
                <v-layout justify-center>
                  <v-btn
                    text
                    @click="disableBtnOperation"
                    :disabled="isDisableBtnDisabled"
                    >Disable</v-btn
                  >
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="mt-10">
          <v-flex>
            <v-autocomplete
              label="Select Currency To Enable"
              chips
              deletable-chips
              multiple
              dense
              v-model="enableBufferList"
              :items="disabledCurrencyList"
              item-text="text"
              item-value="value"
              return-object
              :search-input.sync="searchInput"
              @input="searchInput = null"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs1
            ><v-btn
              text
              :disabled="isEnableBtnDisabled"
              @click="enableBtnOperation"
              >Enable</v-btn
            ></v-flex
          >
        </v-layout>
        <SnackBarNotifier
          buttonTitle="Refresh"
          :isShow="isShowSnackBar"
          :message="responseMessage"
          :buttonOperation="refreshCurrencyLists"
          @eReset="resetSnackBar"
        />
      </v-container>
    </template>
  </WizardStep>
</template>

<script>
import WizardStep from "@/components/wizard/WizardStep";
import CurrencyMixin from "@/components/payment/CurrencyMixin.js";
import SnackBarNotifier from "@/components/widgets/SnackBarNotifier.vue";

export default {
  components: { WizardStep, SnackBarNotifier },
  mixins: [CurrencyMixin],
  data() {
    return {
      searchInput: null,
      isShowSnackBar: false,
      responseMessage: "",
      enableBufferList: [],
      disableBufferList: []
    };
  },
  computed: {
    activeCurrencyTitle() {
      return this.enabledCurrencyList.length > 1
        ? "Enabled Currencies"
        : "Enabled Currency";
    },
    isDisableBtnDisabled() {
      return !this.disableBufferList.length;
    },
    isEnableBtnDisabled() {
      return !this.enableBufferList.length;
    }
  },
  methods: {
    chipCloseAction(currency) {
      currency.enabled = !currency.enabled;
      let isInRemoval = this.disableBufferList.includes(currency);

      isInRemoval
        ? this.removeItemFromList(currency, this.disableBufferList)
        : this.addItemToList(currency, this.disableBufferList);
    },
    isChipDisabled(currencyValue) {
      return currencyValue == this.defaultCurrencyCode ? true : false;
    },
    addItemToList(item, list) {
      list.push(item);
    },
    removeItemFromList(item, list) {
      let itemPosition = list.indexOf(item);
      if (itemPosition >= 0) {
        list.splice(itemPosition, 1);
        return true;
      }
      return false;
    },
    enableBtnOperation() {
      this.enableBufferList.map(async currency => {
        let response = await this.enableCurrency(currency.value);

        if (response.enabled) {
          this.enableFrontEndSteps(currency);
          this.showNotifier("Successfully Enabled Currency.");
          return;
        }

        this.showNotifier("An Error Occurred While Enabling Currency.");
      });

      this.enableBufferList = [];
    },
    enableFrontEndSteps(currency) {
      this.addItemToList(
        this.formatEnableCurrency(currency),
        this.enabledCurrencyList
      );

      this.$nextTick(() => {
        this.removeItemFromList(currency, this.disabledCurrencyList);
      });
    },
    disableBtnOperation() {
      this.disableBufferList.map(async currency => {
        let response = await this.disableCurrency(currency.value);

        if (!response.enabled) {
          this.disableFrontEndSteps(currency);
          this.showNotifier("Successfully Disabled Currency.");
          return;
        }

        this.showNotifier("An Error Occurred While Disabling Currency.");
      });

      this.disableBufferList = [];
    },
    disableFrontEndSteps(currency) {
      this.addItemToList(
        this.formatDisableCurrency(currency),
        this.disabledCurrencyList
      );
      this.$nextTick(() => {
        this.removeItemFromList(currency, this.enabledCurrencyList);
      });
    },
    showNotifier(message) {
      this.isShowSnackBar = true;
      this.responseMessage = message;
    },
    resetSnackBar() {
      this.isShowSnackBar = false;
    },
    formatEnableCurrency(currency) {
      return {
        enabled: true,
        text: currency.text,
        value: currency.value
      };
    },
    formatDisableCurrency(currency) {
      return {
        enabled: false,
        text: currency.text,
        value: currency.value
      };
    }
  },
  async mounted() {
    await this.refreshCurrencyLists();
  }
};
</script>
